import React, { Dispatch, SetStateAction, useState } from 'react'
import styles from './styles.module.css'
import { useSelector } from 'react-redux'
import { useTranslations } from 'next-intl'
import { Box } from '@chakra-ui/react'
import MarkerPinIcon from '@/_assets/icons/MarkerPinIcon'
import { IBranch } from '@/_types'
import { IRedux } from '@/_store/types'
import { branchService } from '@/_service/branch.service'
import { getUserLocation } from '@/_utils/location'
import { useActiveBrand } from '@/_hooks/useActiveBrand'

function NearestBranchControl({
  onSelectBranch,
  setNearestTwoBranches,
}: {
  onSelectBranch: (val: IBranch | null) => void
  setNearestTwoBranches?: Dispatch<SetStateAction<IBranch[]>>
}) {
  const [isLoading, setLoading] = useState(false)
  const shipperId = useActiveBrand()
  const { order_type } = useSelector((state: IRedux) => state.session)
  const deliveryZone = useSelector(
    (state: IRedux) => state.common.deliveryZones?.[shipperId] ?? null
  )
  const t = useTranslations()

  const findNearestBranch = async (lat: number, long: number) => {
    if (isLoading) return

    setLoading(true)
    branchService
      .findNearest(
        {
          lat,
          long,
          order_type_id: order_type?.id,
          delivery_zone_id: deliveryZone?.id || '',
        },
        shipperId
      )
      .then((res) => {
        if (res?.data?.branches) {
          const branches = res?.data?.branches || []

          const selectedBranches = branches.slice(0, 2)
          setNearestTwoBranches?.(selectedBranches)

          for (let branch of res?.data?.branches) {
            if (branch.is_active) {
              onSelectBranch(branch)
              return
            }
          }
        }

        onSelectBranch(null)
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  const handleIsLocation = () => {
    getUserLocation()
      .then((location) => {
        if (location?.latitude) {
          findNearestBranch(location?.latitude, location?.longitude)
        }
      })
      .catch(() => {
        console.log({
          title: t('geolocation_access_required'),
          type: 'warning',
          duration: 5000,
        })
      })
  }

  return (
    <Box
      className={styles.control}
      onClick={() => {
        handleIsLocation()
      }}
      color='text'
    >
      <MarkerPinIcon color='currentColor' />
      {isLoading ? t('loading') : t('find_the_nearest_branch')}
    </Box>
  )
}

export default NearestBranchControl
